<div class="col-md-6 offset-md-3 mt-5">
    <div class="navbar-header" style="background-color: whitesmoke; height: 20%">
      <a class="" rel="studentDetails" href="#" title="Student Details"> </a>
    </div>
  </div>

  <div class="col-md-6 offset-md-3 mt-5">
    <div class="navbar-header">
      <a class="" rel="studentDetails" href="#" title="Student Details">
        <img
          class="responsive"
          style="width: 100%; height: auto"
          src="assets/images/header-1.png"
        />
      </a>
    </div>

    <section
      id="header"
      class="rounded"
      style="
        margin-top: 1%;
        background-color: white;
        text-align: center;
        text-emphasis-color: inherit;
      "
    >
      <strong>IPSR Solutions Limited</strong>
      <div class="container">
        <div class="row">
          <div
            class="col-md-12 col-xs-12 col-centered"
            style="align-items: center; text-decoration: underline"
          >
            <strong> PAYMENT DETAILS </strong>
          </div>
        </div>
      </div>
    </section>

    <div class="card" style="margin-top: 1%">

      <div class="card-body">
        <div *ngIf="!myDIV">
          <form [formGroup]="form" style="padding:20px 120px 0px 106px;" (ngSubmit)="Submit()">


            <div class="form-group">
              <p style="color: red;"><strong>*NOTE : International payments are not accepted through this form.</strong></p>
          </div>

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label>Full Name</mat-label>
                <input
                type="text"
                maxlength="100"
                matInput
                placeholder="Enter Full Name"
                formControlName="fullName"
                autocomplete="off"
                required/>
                <mat-error *ngIf="form.controls['fullName'].hasError('required')">Full Name is required.</mat-error>
                <mat-error *ngIf="form.controls['fullName'].hasError('pattern')">Invalid Full Name</mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label > Mobile No. </mat-label>
                <input type="text" matInput maxlength="10" placeholder="Enter Mobile No." formControlName="mobileNo" autocomplete="off" required/>
                <mat-error *ngIf="form.get('mobileNo').hasError('required')">Mobile No is Required</mat-error>
                <mat-error *ngIf="form.get('mobileNo').hasError('pattern')">Invalid Mobile No.</mat-error>
              </mat-form-field>
            </div>
      
            <div class="form-group" >
              <mat-form-field style="width:100%">
                <mat-label > Email Id </mat-label>
                <input type="text" matInput maxlength="50" placeholder="Enter Email Id" formControlName="emailId" autocomplete="off" required />
               <mat-error *ngIf="form.get('emailId').hasError('required')">Email Id is Required</mat-error> 
                <mat-error *ngIf="form.get('emailId').hasError('pattern')">Invalid Email Id</mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label>Your Place </mat-label>
                <input
                type="text"
                maxlength="100"
                matInput
                placeholder="Enter Your Place"
                formControlName="address"
                autocomplete="off"
                required/>
                <mat-error *ngIf="form.controls['address'].hasError('required')">Your Place is required.</mat-error>
                <!-- <mat-error *ngIf="form.controls['address'].hasError('pattern')">Invalid Address</mat-error> -->
              </mat-form-field>
            </div>

            <div class="form-group" style="width:100%">
              <mat-form-field  style="width:100%">
                <mat-label>Select Course/Service</mat-label>
                <mat-select [(ngModel)]="selectedCourse" formControlName="course" (selectionChange)="courseType($event)" panelClass="testClass" autocomplete="off" required>
                  <mat-option *ngFor="let course of courseList" [value]="course">{{course}}</mat-option>
                </mat-select>
                <mat-error *ngIf="form.controls['course'].hasError('required')">Course/Service are required.</mat-error>
              </mat-form-field>
               </div>

               <div class="form-group"  *ngIf="selectedCourse === 'Others'">
                <mat-form-field style="width:100%">
                  <mat-label>Please Specify</mat-label>
                  <input
                  type="text"
                  maxlength="100"
                  matInput
                  placeholder="Please Specify"
                  formControlName="specifyOther"
                  autocomplete="off"
                  required/>
                  <mat-error *ngIf="form.controls['specifyOther'].hasError('required')">Please Specify is required</mat-error>
                  <!-- <mat-error *ngIf="form.controls['specifyOther'].hasError('pattern')">Invalid Address</mat-error> -->
                </mat-form-field>
              </div>

               <div class="form-group" style="width:100%">
                <mat-form-field  style="width:100%">
                  <mat-label>Select Type of Fees</mat-label>
                  <mat-select formControlName="feesType" panelClass="testClass" autocomplete="off" required>
                    <mat-option *ngFor="let feesType of feesTypeList" [value]="feesType">{{feesType}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="form.controls['feesType'].hasError('required')">Fees Type are required.</mat-error>
                </mat-form-field>
                 </div>
                
                <div class="form-group">
                  <mat-form-field style="width:100%">
                    <mat-label>Name of person you have contacted at IPSR</mat-label>
                    <input
                    type="text"
                    maxlength="100"
                    matInput
                    placeholder="Enter Name of person you have contacted at IPSR"
                    formControlName="contactedPerson"
                    autocomplete="off"
                    />
                    <!-- <mat-error *ngIf="form.controls['contactedPerson'].hasError('required')">Address is required.</mat-error> -->
                    <mat-error *ngIf="form.controls['contactedPerson'].hasError('pattern')">Invalid Name</mat-error>
                  </mat-form-field>
                </div>
               
                <div class="form-group">
                  <mat-form-field style="width:100%">
                    <mat-label>Comments</mat-label>
                    <input
                    type="text"
                    maxlength="100"
                    matInput
                    placeholder="Enter Comments"
                    formControlName="comments"
                    autocomplete="off"/>
                    <!-- <mat-error *ngIf="form.controls['comments'].hasError('required')">Comments is required.</mat-error> -->
                   <!-- <mat-error *ngIf="form.controls['comments'].hasError('pattern')">Invalid Comments</mat-error>  -->
                  </mat-form-field>
                </div>
              

                <div class="form-group">
                  <mat-form-field style="width:100%">
                    <mat-label>Amount</mat-label>
                    <input
                    type="text"
                    matInput
                    max="50"
                    placeholder="Enter Amount"
                    formControlName="amount"
                    autocomplete="off"
                    required/>
                    <mat-error *ngIf="form.controls['amount'].hasError('required')">Amount is required.</mat-error>
                    <mat-error *ngIf="form.controls['amount'].hasError('pattern')">Invalid Amount</mat-error>
                  </mat-form-field>
                </div>

                <div class="form-group">
                  <label> Captcha</label>
                  <input matInput  onpaste="return false;" onCopy="return false" onCut="return false" placeholder="Enter Captcha"
                     class="captchaFeild"  formControlName="captcha" autocomplete="off"
                    minlength="6" maxlength="6"  onkeyup="this.value = this.value.toUpperCase();"  class="form-control" [ngClass]="{ 'is-invalid': submitted && f.captcha.errors }" style="border: 1px solid black;" required />
                    <div *ngIf="submitted && f.captcha.errors " class="invalid-feedback">
                      <div *ngIf="f.captcha.errors.required">Captcha is required</div>
                      <div *ngIf="f.captcha.errors.incorrectcaptcha && (!f.captcha.errors.required)">Captcha is invalid </div>
                      <div *ngIf="f.captcha.errors.minlength && (!f.captcha.errors.required)">Captcha required of length {{f.captcha.errors.minlength.requiredLength}} and has length {{f.captcha.errors.minlength.actualLength}}  </div>
                    </div>
                 </div>
                 <div id="capt">
                     <span onselectstart="return false" onpaste="return false;" onCopy="return false" onCut="return false" onDrag="return false" onDrop="return false">{{initialCap}}</span>
                     <span style="float: right; cursor: pointer;">
                             <i class="material-icons" (click)="Cap()">refresh</i>
                     </span>
                </div>       
  

            <!-- <div class="form-group" >
              <mat-form-field style="width:100%">
                <input type="text" matInput maxlength="50"  formControlName="feeTypeLable" autocomplete="off" />
                 <mat-error *ngIf="form.get('feeTypeLable').hasError('required')">Admission Fees Amount is required.</mat-error>  -->
              <!-- </mat-form-field>
            </div> --> 

            <!-- <div class="form-group" >
          </div>
        </div> -->
          <!-- <div class="form-group">
            <strong> <label for="class"> {{fetchAmount}}</label></strong> 
        </div> -->


  
            
            <!-- <div class="form-group" >
              <mat-form-field style="width:100%">
                <input type="text" matInput maxlength="50"  formControlName="amountLable" [readonly]="true" autocomplete="off" />
                 <mat-error *ngIf="form.get('amountLable').hasError('required')">Admission Fees Amount is required.</mat-error>  -->
              <!-- </mat-form-field>
            </div>  -->

      


            <!-- <div class="form-group" >
              <mat-form-field style="width:100%">
                <input type="text" matInput maxlength="50"  formControlName="feeTypeLable" autocomplete="off" />
                <mat-error *ngIf="form.get('admissionFeeAmount').hasError('required')">Admission Fees Amount is required.</mat-error> 
                <mat-error *ngIf="form.get('admissionFeeAmount').hasError('pattern')">Invalid Admission Fees Amount</mat-error>
              </mat-form-field>
            </div> -->

  

            <div class="form-group" style="
            display: flex;
            margin-top: 30px;
            justify-content: space-evenly;">
              <button
              #submitButton
              style="width: 129px;"
                class="btn btn-primary">
                <span
                  *ngIf="loading"
                  class="spinner-border spinner-border-sm mr-1"></span>
                SUBMIT
              </button>
            </div>
            <div class="errBackButtonDiv" style="width: 129px !important; margin-top: 30px; margin-bottom: 20px;">
            </div>
          </form>

        </div>
        <div>
          <form
            target="_top"
            #txnForm
            [formGroup]="tranxnForm"
            method="POST"
            action="{{ isgPay_url }}"
          >
            <input
              type="hidden"
              [value]="EncDataField"
              name="EncData"
              formControlName="EncData"
            />
            <input
              type="hidden"
              [value]="MerchantIdField"
              name="MerchantId"
              formControlName="MerchantId"
            />
            <input
              type="hidden"
              [value]="BankIdField"
              name="BankId"
              formControlName="BankId"
            />
            <input
              type="hidden"
              [value]="TerminalIdField"
              name="TerminalId"
              formControlName="TerminalId"
            />
            <input
              type="hidden"
              [value]="VersionField"
              name="Version"
              formControlName="Version"
            />
            <input
              type="hidden"
              [value]="TransactionId"
              name="OrderId"
              formControlName="TransactionId"
            />
          </form>
        </div>
      </div>
    </div>
  </div>
